import {RiskClass} from "@app/strain/config/risk-classes/models/risk-class.model";
import { User } from '@models/user.model';

export class ProcessType {

    public id: number;
    public name: string;
    public description: string;
    public inUse: boolean;
    public isDestructive: boolean;
    public technicalEvaluationClass: RiskClass
    public maximumStrainMeasurementValue: number;
    public strainResponsible: User;

    static mapRiskClass(technicalEvaluationClass = {}) {
        return new RiskClass(technicalEvaluationClass || {});
    }

    constructor(processType: any = {}) {
        this.id = processType.id || 0;
        this.name = processType.name || '';
        this.description = processType.description || '';
        this.inUse = processType.inUse;
        this.isDestructive = processType.isDestructive;
        this.technicalEvaluationClass = ProcessType.mapRiskClass(processType.technicalEvaluationClass);
        this.maximumStrainMeasurementValue = processType.maximumStrainMeasurementValue;
        this.strainResponsible = processType.strainResponsible ? new User(processType.strainResponsible) : null;
    }
}
